import { twMerge } from "tailwind-merge";

import Checkbox from "./checkbox";

export interface CheckboxItem {
  id?: string;
  label: string;
  value: string;
}

interface CheckboxListProps {
  items: CheckboxItem[];
  className?: string;
  selectedValue?: string[];
  disabled?: boolean;
  onChange: (selectedIds: string[]) => void;
}

const CheckboxList = ({
  items,
  className,
  selectedValue = [],
  disabled = false,
  onChange
}: CheckboxListProps) => {
  const handleCheckboxChange = (value: string, checked: boolean) => {
    const newSelectedList = checked
      ? [...selectedValue, value]
      : selectedValue.filter((v) => v !== value);

    onChange(newSelectedList);
  };

  return (
    <div className={twMerge("flex gap-2 flex-wrap", className)}>
      {items.map((item) => (
        <Checkbox
          key={item.value}
          id={item.id}
          label={item.label}
          disabled={disabled}
          checked={selectedValue.includes(item.value)}
          onChange={(checked) => handleCheckboxChange(item.value, checked)}
          className={disabled ? "!cursor-not-allowed" : ""}
          inputClassName={
            disabled ? "border-light-gray bg-white !cursor-not-allowed" : ""
          }
          labelClassName={disabled ? "text-light-gray cursor-not-allowed" : ""}
        />
      ))}
    </div>
  );
};

export default CheckboxList;
